<div class="login-button-container" fxLayout="row" fxLayoutAlign="center center">
    <forge-button (click)="return()" telemetry="Submission-ReturnToLogin" variant="raised">
        Return to sign in
    </forge-button>
</div>